import { SequenceGoal } from '../../SequenceGoal/SequenceGoal.types';

export const END_DATE = 'endDate';
export const START_DATE = 'startDate';

export interface EditContentTableProps {
  goals: SequenceGoal[];
  onSubmit: (data: any) => void;
}

export const DATE = {
  MAX: '12/31/2060',
  MIN: '01/01/2020',
};
